import React from 'react';
import {StyleSheet, View} from 'react-native';

import Button from '../../components/ui-controls/Button';
import {OrderLine} from '../../transport/apiServiceResponse';

const byPriceAsc = (a: OrderLine, b: OrderLine) =>
  a.normal_price_cents - b.normal_price_cents;

type CardSelectorProps = {
  products: OrderLine[];
  onSelectProduct: (product: OrderLine) => void;
  selectedProduct: OrderLine | null;
};
const CardSelector = ({
  products = [],
  onSelectProduct,
  selectedProduct,
}: CardSelectorProps) => (
  <View style={styles.main}>
    {[...products].sort(byPriceAsc).map(product => (
      <View key={product.product_id} style={styles.product}>
        <CardButton
          product={product}
          onSelectProduct={onSelectProduct}
          selected={selectedProduct?.product_id === product.product_id}
        />
      </View>
    ))}
  </View>
);

type CardButtonProps = {
  product: OrderLine;
  selected: boolean;
  onSelectProduct: (product: OrderLine) => void;
};
const CardButton = ({product, selected, onSelectProduct}: CardButtonProps) => (
  <Button
    title={`$${product.normal_price_cents / 100}`}
    onPress={() => onSelectProduct(product)}
    buttonStyle={{width: '100%'}}
    type={selected ? 'solid' : 'outline'}
  />
);

const styles = StyleSheet.create({
  main: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  product: {
    width: '30%',
  },
});

export default CardSelector;
